module.exports = __webpack_public_path__ + "img/HeBo Trailers-16.fb2e00ea.jpg";